(() => {
  const galleryEl = document.getElementById("ProductGallery");
  const templatesRoot = document.getElementById("ProductGalleryTemplates");
  const variantsJSON = document.getElementById("ProductVariantsJSON");
  if (!galleryEl || !templatesRoot || !variantsJSON) return;

  const colorPos = Number(galleryEl.getAttribute("data-color-pos") || "0");
  if (!colorPos) return;

  let variants = [];
  try {
    variants = Array.isArray(window.ProductVariants)
      ? window.ProductVariants
      : JSON.parse(variantsJSON.textContent || "[]");
  } catch {}

  const form =
    document.getElementById("add-to-cart-form") ||
    document.querySelector("[data-product-form]") ||
    document.querySelector('form[action*="/cart/add"]');

  const idInput = form ? form.querySelector("[data-variant-input]") : null;

  const normalize = (s) => (s || "").trim().toLowerCase();
  const escapeAttr = (s) => (s || "").replace(/["\\]/g, "\\$&");

  function currentVariantById() {
    const id = Number(idInput?.value || 0);
    if (!id) return null;
    return variants.find((v) => Number(v.id) === id) || null;
  }

  function currentColor() {
    const v = currentVariantById();
    if (!v) return "";
    if (colorPos === 1) return v.option1;
    if (colorPos === 2) return v.option2;
    if (colorPos === 3) return v.option3;
    return "";
  }

  function currentColorFromUI() {
    try {
      const btn = form?.querySelector(
        `.variant-option.is-selected[data-option-position="${colorPos}"]`
      );
      return btn ? btn.getAttribute("data-option-value") || "" : "";
    } catch (_) {
      return "";
    }
  }

  function getColorFromURL() {
    try {
      const url = new URL(window.location.href);
      return (
        url.searchParams.get("option1") ||
        url.searchParams.get("color") ||
        url.searchParams.get("colour") ||
        ""
      );
    } catch (_) {
      return "";
    }
  }

  function getColorFromVariantIdInURL() {
    try {
      const url = new URL(window.location.href);
      const id = Number(url.searchParams.get("variant") || 0);
      if (!id) return "";
      const v = variants.find((vv) => Number(vv.id) === id);
      if (!v) return "";
      if (colorPos === 1) return v.option1 || "";
      if (colorPos === 2) return v.option2 || "";
      if (colorPos === 3) return v.option3 || "";
      return "";
    } catch (_) {
      return "";
    }
  }

  function computeColor() {
    const ssr = galleryEl.getAttribute("data-current-color") || "";
    return (
      currentColor() ||
      getColorFromVariantIdInURL() ||
      currentColorFromUI() ||
      getColorFromURL() ||
      ssr ||
      ""
    );
  }

  let hasInitialized = false;

  function renderByColor(color) {
    const prev = normalize(galleryEl.getAttribute("data-current-color") || "");
    const key = normalize(color);
    if (!key) return;
    let tpl = templatesRoot.querySelector(
      `template[data-color="${escapeAttr(key)}"]`
    );
    if (!tpl && hasInitialized && idInput && idInput.value) {
      tpl = templatesRoot.querySelector(`template[data-default="true"]`);
    }
    if (!tpl) return;
    if (key === prev) return;
    galleryEl.innerHTML = tpl.innerHTML;
    galleryEl.setAttribute("data-current-color", key);
  }

  function initialRender() {
    renderByColor(computeColor());
    hasInitialized = true;
  }
  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", () => {
      (window.requestAnimationFrame || setTimeout)(initialRender, 0);
      setTimeout(() => renderByColor(computeColor()), 50);
    });
  } else {
    (window.requestAnimationFrame || setTimeout)(initialRender, 0);
    setTimeout(() => renderByColor(computeColor()), 50);
  }

  if (form) {
    form.querySelectorAll(".option-group").forEach((group) => {
      group.addEventListener("click", () => {
        setTimeout(() => renderByColor(computeColor()), 0);
      });
    });
  }

  if (idInput) {
    const rerender = () => renderByColor(computeColor());
    idInput.addEventListener("change", rerender);
    const obs = new MutationObserver(rerender);
    obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
  }

  document.addEventListener("variant:change", (e) => {
    const v = e.detail?.variant;
    if (!v) return;
    const color =
      colorPos === 1 ? v.option1 : colorPos === 2 ? v.option2 : v.option3;
    renderByColor(color);
  });
})();
